import React from "react";
import { Row, Statistic, Table, Tag } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons/lib";
import { useRiskReturnData } from "./hook";

import styles from "../styles.less";

export default () => {
  const riskReturnData = useRiskReturnData();

  const columns = [
    {
      title: "Backtest Type",
      dataIndex: "name",
      key: "name",
      render: (value: string) => (
        <Tag className={styles.tag} color={"blue"}>
          {value}
        </Tag>
      )
    },
    {
      title: "Cumulative Return",
      dataIndex: "cumRtn",
      key: "cumRtn",
      render: (value: number) => (
        <Row justify={"center"}>
          <Statistic
            value={value}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Annualized Return (CAGR)",
      dataIndex: "annualRtn",
      key: "annualRtn",
      render: (value: number) => (
        <Row justify={"center"}>
          <Statistic
            value={value}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Annualized Volatility",
      dataIndex: "annualVol",
      key: "annualVol",
      render: (value: number) => (
        <Row justify={"center"}>
          <Statistic value={value} precision={2} valueStyle={{ color: "#616161" }} suffix="%" />
        </Row>
      )
    },
    {
      title: "Sharpe Ratio",
      dataIndex: "sharpeRatio",
      key: "sharpeRatio",
      render: (value: number) => (
        <Row justify={"center"}>
          <Statistic value={value} precision={2} valueStyle={{ color: "#616161" }} />
        </Row>
      )
    }
  ];

  return <Table dataSource={riskReturnData} columns={columns} pagination={false} />;
};
